module.exports = __webpack_public_path__ + "img/19-2.5722c830.png";